import useCategory from './useCategory';
export default function useSubCategories(categoryId) {
    const category = useCategory(categoryId);
    if (!category)
        return;
    return category.subCategories;
}
//# sourceMappingURL=useSubCategories.js.map